import React from 'react';
import {useTranslation} from 'react-i18next';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Run_old({action, setOpenVariable, variables}) {
    const {t} = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.PYTHON.RUN.';
    return (
        <>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'CHOOSE-SCRIPT')} is_required/>
                <VariablePicker action={action} inputName="script" variables={variables}
                                setOpenVariable={setOpenVariable} isRequired hideRequired/>
            </div>
            {/* <div className="conf-field-container">
                {t(label + 'EXECUTED-FUNCTION')}
                <TextInput action={action} inputName="function" variables={variables} setOpenVariable={setOpenVariable}/>
            </div>
            <div className="conf-field-container">
                {t(label + 'PARAMETERS')}
                <VariablePicker action={action} inputName="parameters" variables={variables} setOpenVariable={setOpenVariable}/>
            </div> */}
            <div className="conf-field-container">

                <FieldLabel name={t(label + 'ASSIGN')} is_required/>
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                                isRequired hideRequired/>
                <small
                    className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', {type: 'string'})}</em></small>
            </div>
        </>
    );
}

export default Run_old;